import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { User } from '@supabase/supabase-js'
import type { User as AppUser } from '../types/database'

interface AuthState {
  user: User | null
  appUser: AppUser | null
  isLoading: boolean
  authError: string | null
  setUser: (user: User | null) => void
  setAppUser: (appUser: AppUser | null) => void
  setIsLoading: (isLoading: boolean) => void
  setAuthError: (error: string | null) => void
  signOut: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      appUser: null,
      isLoading: true,
      authError: null,
      setUser: (user) => set({ user }),
      setAppUser: (appUser) => set({ appUser }),
      setIsLoading: (isLoading) => set({ isLoading }),
      setAuthError: (authError) => set({ authError }),
      signOut: () => set({ user: null, appUser: null }),
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({ appUser: state.appUser }),
    }
  )
)
